import { create } from '@thoughtspot/logger';
import { getTranslatedValue, validateGetLabelTranslationsPayloadObject, } from './utils';
const logger = create('chart-to-ts > get-label-translation-events');
const validateGetLabelTranslationsPayload = (eventData) => {
    const payload = eventData.payload;
    try {
        validateGetLabelTranslationsPayloadObject(payload);
    }
    catch (err) {
        logger.warn(err);
        return {
            isValid: false,
            errors: [err.toString()],
        };
    }
    return {
        isValid: true,
    };
};
export const getLabelTranslationsProcessor = (props) => {
    return {
        validateEventPayload: (eventData) => {
            return validateGetLabelTranslationsPayload(eventData);
        },
        executeEvent: async (eventData) => {
            const res = getTranslatedValue(eventData.payload.msgIds);
            return Promise.resolve(res);
        },
    };
};
//# sourceMappingURL=index.js.map